var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99998 26C8.19561 24.4441 6.52312 22.7384 4.99999 20.9007C2.71428 18.1409 1.25556e-06 14.0308 1.25556e-06 10.1142C-0.000990025 8.11399 0.585012 6.15842 1.68384 4.49501C2.78268 2.83159 4.34495 1.5351 6.17294 0.769605C8.00093 0.00411112 10.0125 -0.195973 11.953 0.194676C13.8935 0.585324 15.6758 1.54914 17.0742 2.96416C18.0053 3.90122 18.7433 5.01564 19.2455 6.24295C19.7477 7.47025 20.0041 8.78606 20 10.1142C20 14.0308 17.2857 18.1409 15 20.9007C13.4768 22.7384 11.8043 24.4441 9.99998 26ZM9.99998 5.78172C8.86334 5.78172 7.77325 6.23818 6.96953 7.05068C6.1658 7.86318 5.71427 8.96516 5.71427 10.1142C5.71427 11.2633 6.1658 12.3652 6.96953 13.1777C7.77325 13.9902 8.86334 14.4467 9.99998 14.4467C11.1366 14.4467 12.2267 13.9902 13.0304 13.1777C13.8342 12.3652 14.2857 11.2633 14.2857 10.1142C14.2857 8.96516 13.8342 7.86318 13.0304 7.05068C12.2267 6.23818 11.1366 5.78172 9.99998 5.78172Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.bb257429d649df94b0fde5fa929d9ba6.svg";
export { ForwardRef as ReactComponent };